import { render } from "./larga.vue?vue&type=template&id=42131a74"
import script from "./larga.vue?vue&type=script&lang=js"
export * from "./larga.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__